import { TOKEN_VALUE, TOKEN_TYPE } from '../commons/constants';

export const interceptorRequest = function(request) {
    const tokenType = localStorage.getItem(TOKEN_TYPE)
    const token = localStorage.getItem(TOKEN_VALUE)
    request.headers.Authorization = `${tokenType} ${token}`
    return request
}

export const handlerErrorRequest = function(error) {
    console.error(error)
    return Promise.reject(error)
}